import React from 'react';
import {
    required,
    TextInput,
    DateInput,
    SimpleForm,
    Create,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Months from '../../controls/Months'
import Years from '../../controls/Years'
import jwt_decode from 'jwt-decode'
import { Redirect } from 'react-router-dom';
import ErrorBoundary from '../../ErrorBoundary';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none'
     },
     inputStyle : {
         width :'20px',
     },
     controlInputStyle : {
        width :'70px',
        fontSize: '8'
    },
     labelStyle : {
        width :'40px',
        backgroundColor: 'silver'
    },
    iniLabelStyle : {
        width :'20px',
        backgroundColor: 'silver'
    },
    dateStyle : {
        width: '120px',
        
    },
    tableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'1px solid  black', 
        width: "100%"
    },
    h3: {
        textAlign: 'center',
        width: '100%'
    },
    clearTableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'0px solid  black', 
        width: "100%"
    },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },

 };
 
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);


const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);


const InstCreate = ({classes, ...props }) => (
<ErrorBoundary>  
    <Create actions={<UserCreateActions />}   {...props}>
        <SimpleForm toolbar={<UserCreateToolbar />} >
            {(props && props.location && props.location.ins_id && props.location.ins_id != null && props.location.ins_id != '') ? 
            <>
            <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>MICROHEMATOCRIT CENTRIFUGE</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center'  label='' defaultValue={loc} disabled/></td>
                        <td>Month/Year:</td>
                        <td><SelectInput source='months' label='' choices={Months} />&nbsp;
                            <SelectInput source='years' label='' choices={Years} />
                        </td>
                    </tr>
                    <tr>
                        <td>Equipment ID:</td><td><TextInput source='ins_id'  label='' disabled defaultValue={(props && props.location)?( (props.location.ins_id)?props.location.ins_id:ins_id):ins_id}/></td>
                        <td>Booth:</td><td><TextInput source='booth'  label='' /></td>
                    </tr>
                </tbody>
            </table>
            <table className={classes.tableStyle} >
                <tbody  > 
                    <tr >
                        <td className={classes.labelStyle}>Daily Control</td>
                        <td className={classes.labelStyle}>Normal Control</td>
                        <td className={classes.labelStyle}>Low Control</td>
                        <td className={classes.labelStyle}>High Contorl</td>
                        <td className={classes.iniLabelStyle}>Initial</td>
                        <td className={classes.labelStyle}>Date</td>
                        <td className={classes.iniLabelStyle}>QA Initial</td>
                        <td className={classes.labelStyle}>QA Date</td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Manufacturer</td>
                            <td className={classes.controlInputStyle} ><TextInput source="man_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="man_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="man_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_date"    label=""  locales="en-us"   /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Lot Number</td>
                            <td className={classes.controlInputStyle} ><TextInput source="lot_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="lot_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="lot_high"    label="" /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_init"    label="" /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_date"    label=""  locales="en-us"   /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_qa_init"    label="" /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_qa_date"    label=""  locales="en-us" /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Manufaturer expiration</td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_nor"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_low"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Range</td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial opened</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial expires</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_date"    label=""  locales="en-us"  /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                </tbody>
            </table>
          
                        <ArrayInput source="details">
                            <SimpleFormIterator  disableReordering >
                                <DateInput formClassName={classes.inlineBlock} source="dt" label='Date' /> 
                                <TextInput formClassName={classes.inlineBlock} source="nor" label='Normal %'/>
                                <TextInput formClassName={classes.inlineBlock} source="low" label='Low %'/>
                                <TextInput formClassName={classes.inlineBlock} source="high" label='High %'/>
                                <TextInput formClassName={classes.inlineBlock} source="comm" label='Comments'/>
                                <TextInput formClassName={classes.inlineBlock} source="t_init" label='Tech Initial'/>
                                <DateInput formClassName={classes.inlineBlock} source="t_date" label='Tech Date'/>
                                <FormDataConsumer>
                                        {({
                                            formData, // The whole form data
                                            scopedFormData, // The data for this item of the ArrayInput
                                            getSource, // A function to get the valid source inside an ArrayInput
                                            ...rest
                                        }) =>
                                            role && ( role==='QA' || level === 7 )? (
                                                <>
                                                &nbsp;&nbsp;&nbsp;<TextInput formClassName={classes.inlineBlock} source="q_init" label='QA Initial'/>&nbsp;
                                                &nbsp;&nbsp;&nbsp;<DateInput formClassName={classes.inlineBlock} source="q_dt" label='QA Date' />&nbsp;
                                                &nbsp;&nbsp;&nbsp;<BooleanInput formClassName={classes.inlineBlock} source="is_qa" label='QA Approved'/>
                                                </>
                                            ) : <>
                                                &nbsp;&nbsp;&nbsp;<TextInput formClassName={classes.inlineBlock} source="q_init" label='QA Initial' disabled/>&nbsp;  
                                                &nbsp;&nbsp;&nbsp;<DateInput formClassName={classes.inlineBlock} source="q_dt" label='QA Date' disabled />&nbsp;
                                                &nbsp;&nbsp;&nbsp;<BooleanInput formClassName={classes.inlineBlock} source="is_qa" label='QA Approved' disabled/>
                                                </>
                                        }
                                </FormDataConsumer>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </>
             : <Redirect to='/calinstrument' /> }
        </SimpleForm>
        
    </Create> 
</ErrorBoundary>  
);

export default  withStyles(styles) (InstCreate);
